<script>
// Functions
import { toThaiDatetime } from '@/utils/datetime'

export default {
  props: {
    title: {
      type: String,
      default: ''
    },

    date: {
      type: Date,
      default: null
    },

    dueDate: {
      type: Date,
      default: null
    }
  },

  render() {
    const dueDate = [
      <span style={{ fontWeight: 'bold', marginRight: '0.5rem' }}>
        วันที่ครบกำหนดใหม่:
      </span>,
      toThaiDatetime(this.dueDate)
    ]

    return (
      <div class={this.$style.root}>
        <el-row
          type="flex"
          gutter={32}
          align="bottom"
          style={{ flexWrap: 'wrap', marginBottom: '0.5rem' }}
        >
          <el-col
            sm={this.dueDate && this.$mq !== 'sm' ? 12 : undefined}
            style={{ fontWeight: 'bold' }}
          >
            <span style={{ fontSize: '1.25rem' }}>&bull; {this.title}</span>
            {this.date && (
              <span style={{ marginLeft: '0.5rem' }}>
                : {toThaiDatetime(this.date)}
              </span>
            )}
          </el-col>
          {this.dueDate && this.$mq !== 'sm' && (
            <el-col sm={12} style={{ textAlign: 'right' }}>
              {dueDate}
            </el-col>
          )}
        </el-row>
        {this.$slots.default}
        {this.dueDate && this.$mq === 'sm' && (
          <div style={{ marginTop: '1rem' }}>{dueDate}</div>
        )}
      </div>
    )
  }
}
</script>

<style lang="scss" module>
.root {
  padding: 1rem 0;

  & + & {
    border-top: 1px solid $--border-color-base;
  }
}
</style>
